import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AssignedPub} from 'typescript/models/AssignedPub';
import User from 'typescript/models/User';

interface IState {
  singleEditor: User | null;
  assignedPubs: AssignedPub[];
  unassignPubData: {
    editorName: string;
    editorId: string;
    assignedPubId: string;
    pubName: string;
    pubId: string;
  } | null;
}

const initialState: IState = {
  singleEditor: null,
  assignedPubs: [],
  unassignPubData: null,
};

export const singlePageEditorNamespace = 'singlePageEditor';

const singlePageEditorSlice = createSlice({
  name: singlePageEditorNamespace,
  initialState,
  reducers: {
    setSingleEditorAC: (state, action: PayloadAction<User | null>) => {
      state.singleEditor = action.payload;
    },
    setAssignedPubsAC: (state, action: PayloadAction<AssignedPub[]>) => {
      state.assignedPubs = action.payload;
    },
    setUnassignPubData: (state, action: PayloadAction<IState['unassignPubData']>) => {
      state.unassignPubData = action.payload;
    },
  },
});

export default singlePageEditorSlice;

export const {setSingleEditorAC, setAssignedPubsAC, setUnassignPubData} = singlePageEditorSlice.actions;
